import AlertService from "../../services/notification.service";

export const handlePaste = (e: any) => {
  const pastedText = e.clipboardData.getData("text");
  if (!(/^\d+$/.test(pastedText))) {
    e.preventDefault();
    AlertService.warning('Please insert only positive integers');
  }
}

export const handlePasteTypesBlock = (e: any) => {
  const pastedText = e.clipboardData.getData("text");
  if (!(/^\d*\.?\d*$/.test(pastedText))) {
    e.preventDefault();
    AlertService.warning('Please insert only positive number');
  }
}